import bemMixin from '../_mixins/bem';
import { isSSR as _isSSR } from './constant';
export var prefix = 'gd';
export function createComponentName(name) {
  return "".concat(prefix, "-").concat(name);
}
export var componentMixin = {
  mixins: [bemMixin],
  computed: {
    $$attrs: function $$attrs() {
      var attrs = {};

      for (var key in this.$attrs) {
        if (!this.$hasProp(key)) {
          attrs[key] = this.$attrs[key];
        }
      }

      return attrs;
    }
  },
  methods: {
    ignoreListeners: function ignoreListeners(keys) {
      var listeners = {};

      for (var key in this.$listeners) {
        if (keys.indexOf(key) === -1) {
          listeners[key] = this.$listeners[key];
        }
      }

      return listeners;
    },
    $hasProp: function $hasProp(key) {
      return key in this.$options.propsData && this.$options.propsData[key] !== undefined;
    },
    isSSR: function isSSR() {
      return _isSSR();
    }
  }
};